import { DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { UpsellAttachmentBadge } from "../UpsellAttachmentBadge";

interface Props {
  isDraft: boolean;
  attachmentPath: string | null;
  attachmentFilename: string | null;
}

/** Dialog-tittelraden i UpsellEditDialog (utkast-badge + vedlegg-badge). */
export function UpsellEditHeader({ isDraft, attachmentPath, attachmentFilename }: Props) {
  return (
    <DialogHeader>
      <DialogTitle className="flex items-center gap-2 flex-wrap">
        Rediger mersalg
        {isDraft && (
          <span className="text-[10px] px-1.5 py-0.5 rounded bg-amber-100 text-amber-800 uppercase tracking-wider">
            Utkast
          </span>
        )}
        {attachmentPath && (
          <UpsellAttachmentBadge path={attachmentPath} filename={attachmentFilename} />
        )}
      </DialogTitle>
    </DialogHeader>
  );
}
